import * as actionTypes from '../actions/actionTypes';

const initialState = {
    rowData: null,
}

const partRequestReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_PR_DETAIL:
         
            return {
                ...state,
                rowData: action.rowData

            }
        default:
            return state;

    }
}

export default partRequestReducer;
